import { Box } from '@chakra-ui/react';
import { Button } from 'src/components/atoms/Button';
import { useFilterContext } from 'src/contexts/FilterContext';

type CreateOptimizationButtonProps = {
  onClick: () => void;
};

export const CreateOptimizationButton: React.FC<
  CreateOptimizationButtonProps
> = ({ onClick }) => {
  const { currentModelVersion } = useFilterContext();

  return (
    <Box>
      <Button
        buttonName="create-optimization"
        disabled={!currentModelVersion}
        onClick={onClick}>
        Create optimization
      </Button>
    </Box>
  );
};
